module.exports = __webpack_public_path__ + "img/pic_map_germany_S.4418e0cd.jpg";